// export const BASE_API = "http://127.0.0.1:8000";

export const BASE_API = (process.env.REACT_APP_API_BASE || "/api").trim();

export const TOKEN = "token";
